import { render, staticRenderFns } from "./VideoOpen.vue?vue&type=template&id=0a9c971d&"
import script from "./VideoOpen.vue?vue&type=script&lang=js&"
export * from "./VideoOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports